

































import { defineComponent, ref } from '@nuxtjs/composition-api'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ru'

import '@/assets/styles/datepicker.scss'

export default defineComponent({
  name: 'InputDate',
  components: {
    DatePicker,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    format: {
      type: String,
      default: 'DD.MM.YYYY',
    },
    formType: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    error: {
      type: [String, Boolean],
      default: '',
    },
  },
  setup(props: any, ctx) {
    const isFocused = ref(false)
    const onChange = ($event: string) => {
      ctx.emit('input-change', $event)
      ctx.emit('input', $event)
    }
    const onOpen = () => {
      if (!process.client) return
      const datepicker: any = ctx.root.$el.querySelector('.mx-datepicker')
      const width = datepicker.getBoundingClientRect().width - 2

      setTimeout(() => {
        const body: any = document.querySelector('.mx-datepicker-body')
        body.setAttribute('style', `width:${width}px`)
      }, 0)
    }

    // Функция для отключения будущих дат
    const disableFutureDates = (date: Date) => {
      if (
        props.formType === 'studentDms' ||
        props.formType === 'studentDmsEng'
      ) {
        const today = new Date()
        today.setHours(23, 59, 59, 999) // Устанавливаем конец текущего дня
        return date > today
      }
      return ''
    }

    return {
      onChange,
      onOpen,
      isFocused,
      disableFutureDates,
    }
  },
})
